/**
 * @typedef {{
 *  name: string,
 *  type: "texture" | "hdr" | "gltf",
 *  path: string,
 *  preload: boolean,
 *  mobileVariant?: string
 * }} ResourcesManifestEntry
 */

/** @type {ResourcesManifestEntry[]} */
export const resourcesManifest = [
  {
    name: "background",
    type: "texture",
    path: "/static/images/neukirch-2400.webp",
    mobileVariant: "/static/images/neukirch-2400.jpg",
    preload: true
  },
  {
    name: "portrait",
    type: "texture",
    path: "/static/images/paul2-1200.webp",
    mobileVariant: "/static/images/paul2-1200.jpg",
    preload: true
  },
  {
    name: "project-bvv",
    type: "texture",
    path: "/static/images/consulting.webp",
    preload: true
  },
  {
    name: "project-inpott",
    type: "texture",
    path: "/static/images/inpott_project.webp",
    preload: true
  },
  {
    name: "project-landingpage",
    type: "texture",
    path: "/static/images/landingpage_project.webp",
    preload: true
  },
  {
    name: "project-smarthome",
    type: "texture",
    path: "/static/images/smarthome_project.webp",
    preload: true
  },
  {
    name: "studio-hdr",
    type: "hdr",
    path: "/new/assets/hdr/studio_small_03_1k.hdr",
    preload: true
  },
  {
    name: "hero-model",
    type: "gltf",
    path: "/new/assets/models/damaged-helmet.glb",
    preload: true
  }
];
